import React, { Component } from "react";
import { Divider } from "antd";
import PropTypes from 'prop-types';
import Chart from "./Components/chart/chart";
import HistoricNav from "./Components/HistoricalNav/HistoricNav";
import TooltipComponent from "../../../../CommonComponents/Info/Tooltip/TooltipComponent";
import {formatAmount, initiateTracking} from "../../../../utils/commonUtil";
import {
  InvestmentTable,
  ChartArea,
  ProgressCircle,
  ProgressLabelContainer,
  ProgressLabel,
  Goal,
  Benchmark,
  CashSquare,
  StockSquare,
  ClearTable,
  ProgressUpdated,
  PoolDesc,
  IODivider,
  ShowPercentage
} from "./styles";
import { DataValue, DataHeading, DisplayFlex, JustifyAround } from "../../../../CommonComponents/commonStyles";
import ClipDivision from "../../../../CommonComponents/ClipDivison/ClipDivision";
import PrintTable from "../../../../CommonComponents/PrintTable/PrintTable";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { investmentInvestmentOptionDetailsDerivedStates } from "./selectors";
import { CapsuleButton } from "../../../../CommonComponents/Commons/commonComponents";
let priceTable = [];
let tabSelected = "PB";
class InvestmentOptionDetailsWeb extends Component {
  constructor(props) {
    super(props); 
    this.showMoreButtonTitle = 'Show More';
    this.state = {
      expandedRow: [],
      exportTabsData: {}
    }
  }

  componentDidMount(){
    this.props.exportDataUpdate && this.props.exportDataUpdate(this.props.fundData)    
  }

  trackAnalytics(tabName, data) {
    initiateTracking("showMore", this.props.getPageTitle(), tabName, `${this.showMoreButtonTitle} - ${data.investmentOption}`);
    return tabName;
  }

  showMore = (data) => {
    let tabName = '';
    switch(data.type){
      case 'ps': tabName = 'Portfolio Solutions'; break;
      case 'pb': tabName = 'Portfolio Builders'; break;
      case 'vdi': tabName = 'Values-driven Investments'; break;
      default: tabName = 'My Investments'; break;
    }
    this.trackAnalytics(tabName, data);    
    return true;
  }

  NestedTable = (record, index, indent, expanded) => {
    const columns = this.props.expandConfig;      
    const data = [];

    this.props.fundData &&
      this.props.fundData.forEach((each, i) => {          
        if (i === parseInt(record.key)) {
          each.expandedData.forEach((item, index) => {
            data.push({
              key: index,
              investmentOption: item.investmentOption,
              category: item.category,
              returnsYTD: item.returnsYTD,
              oneY: item.oneY,
              fiveY: item.fiveY,
              tenY: item.tenY,
              stdExpRatio: item.stdExpRatio,
              selExpRatio: item.selExpRatio,
              currentNAV: "",
              url: item.field_fund,
              investmentPercentage: item.field_funds_percentage,
              availableUnits: item.availableUnits,
              expRatio: item.expRatio,
              currentBalance: item.currentBalance
            });
          });

          priceTable = each.priceTable.map((unitp) => {
            unitp.unitPrice = parseFloat(unitp.unitPrice).toFixed(2);
            return unitp;
          });
        }
      });    

    return (
      <div>
        <ClearTable
          className="expanded"
          rowClassName="expandedRow"
          columns={columns}
          dataSource={data}
          pagination={false}
          showHeader={false}
        />
        <DisplayFlex className="mt2">
          {/* <ChartArea>
            <DataValue className="mb2">Returns chart</DataValue>
            <Chart data={record} />
          </ChartArea> */}
          {/* <IODivider type="vertical" className="mx3" /> */}
          <HistoricNav priceTable={priceTable} record={record} />
          <IODivider type="vertical" className="mx3 flex-shrink"/>
          <showMoreRightPlace>
            <PoolDesc>
              <DataValue className="navy-color mb-10">Description</DataValue>
              {record.description ? (
                <DataHeading>{record.description}</DataHeading>
              ) : (
                <DataHeading> &mdash; </DataHeading>
              )}
            </PoolDesc>
            <JustifyAround className="mt2 showmore-content">
              <div>
                <DataValue className="navy-colo mb-10r">
                  Risk/granting time horizon
                </DataValue>
                <ClipDivision risk={record.risk} tab={record.type.toString()} />
              </div>
              <div>
                <DataValue className="navy-color mb-10">Goal</DataValue>
                <Goal>{this.props.fundData && this.props.fundData[record.key].goal}</Goal>
              </div>
              {this.props.fundData && this.props.fundData[record.key].type === "ps" && (
                <div>
                  <DataValue className="mb-10">Target Allocation</DataValue>
                  <DisplayFlex>
                    <ProgressCircle>
                      <ProgressUpdated
                        type="circle"
                        percent={parseFloat(this.props.fundData[record.key].value1)}
                        format={() => ""}
                        strokeWidth={10}
                        width={56}
                        strokeLinecap="square"
                        strokeColor={"#0098db"}
                      />
                    </ProgressCircle>
                    <ProgressLabelContainer>
                      <DisplayFlex>
                        <CashSquare color={"#0098db"} />
                        <ProgressLabel>
                          {this.props.fundData &&
                            <>
                              <ShowPercentage>
                                {this.props.fundData && `${this.props.fundData[record.key].value1}%`}{' '}
                              </ShowPercentage>
                              {`${this.props.fundData[record.key].label1}`}
                            </>
                          }
                        </ProgressLabel>
                      </DisplayFlex>
                      <DisplayFlex>
                        <StockSquare />
                        <ProgressLabel>
                          {this.props.fundData &&
                            <>
                              <ShowPercentage>
                                {this.props.fundData && `${this.props.fundData[record.key].value2}%`}{' '}
                              </ShowPercentage>
                              {`${this.props.fundData[record.key].label2}`}
                            </>
                          }
                        </ProgressLabel>
                      </DisplayFlex>
                    </ProgressLabelContainer>
                  </DisplayFlex>
                </div>
              )}

              {this.props.fundData && this.props.fundData[record.key].type !== "ps" && (
                <div className={tabSelected === "PS" ? "display-none" : "block"}>
                  <DataValue className="navy-color mb-10">Benchmark</DataValue>                
                  {this.props.fundData[record.key].benchmark === "" ? (
                    <>&mdash;</>
                  ) : (
                    <Benchmark>{this.props.fundData[record.key].benchmark}</Benchmark>
                  )}
                </div>
              )}
              <div>
                <DataValue className="navy-color mb-10">
                  Management
                  <TooltipComponent placement="left" text="Active funds focus on outperforming the market compared to a specific benchmark through a portfolio manager's selections. Passive funds seek to mimic benchmarks by tracking an index." />
                </DataValue>
                <DataHeading>
                  {this.props.fundData && this.props.fundData[record.key].management}
                </DataHeading>
              </div>
            </JustifyAround>
          </showMoreRightPlace>
        </DisplayFlex>
      </div>
    );
  };

  expandToggler = (value = '') => {
    const params = this.props.location.state;    
    if(params && params.hasOwnProperty("poolName")) {
      this.props.history.push({
        pathname: '/investments/details',
      });
    }    
    this.setState({
      expandedRow: value ? [value.toString()]: []
    });
  }

  ExportDataexpandToggler = (pagination, filters, sorter, extra ) => {
    this.expandToggler();
    this.props.exportDataUpdate(extra.currentDataSource);
  }
    
  CustomExpandIcon = (props) => {    
    return props.expanded ? (

  
<CapsuleButton text= " Show Less"  id={`btnShowLess${props.record.key}`}  onClick={e => {
        this.expandToggler();               
      }} whiteBackground iconType="arrowUp" width="117px" />  

    ) : (
  
<CapsuleButton text=  {this.showMoreButtonTitle} id={`btnShowMore${props.record.key}`} onClick={e => {          
          this.showMore(props.record);
          this.expandToggler(`iod_${props.record.key}`);          
        }} whiteBackground iconType="arrowDown" width="117px" />  
    );
  }

  /****************************************/
  render() {  
    const params = this.props.location.state;
    const poolName = params && params.hasOwnProperty("poolName") ? params.poolName: '';
    if(poolName && this.props.fundData) {      
      let rowKey = this.props.fundData.findIndex((i) => i.investmentOption === poolName);      
      this.state.expandedRow = rowKey > -1 ? [`iod_${rowKey}`]: [];
    }

    const Dash = () => <DataHeading> &mdash; </DataHeading>;
    const data = [];
    const preview = [];    
    this.props.fundData &&
      this.props.fundData.forEach((item, index) => {
        let benchmark = {};
        let isBenchmark = -1;

        if(item.expandedData !== null && typeof item.expandedData === 'object' 
          && item.expandedData.hasOwnProperty('length') && item.expandedData.length > 0){
          isBenchmark = item.expandedData.findIndex(o => o.field_fund === 'Benchmark Return');
        }    

        if (isBenchmark > -1) {
          let analytics = item.expandedData[item.expandedData.length - 1];
          benchmark.returnsYTD = analytics.returnsYTD
            ? analytics.returnsYTD
            : null;
          benchmark.oneY = analytics.oneY;
          benchmark.fiveY = analytics.fiveY;
          benchmark.tenY = analytics.tenY;
          benchmark.selExpRatio = analytics.selExpRatio;
          benchmark.stdExpRatio = analytics.stdExpRatio;
        }

        preview.push({
          key: index,
          // In my investment tab if any extra columns added then this condition won't work for select accounts. Change the condition accordingly.
          investmentOption: this.props.columnConfig.length!==5?item.investmentOption.replace(" Select",""):item.investmentOption,
          returnsYTD: item.returnsYTD ? `${item.returnsYTD}%` : <Dash />,
          oneY: item.oneY ? `${item.oneY}%` : <Dash />,
          fiveY: item.fiveY ? `${item.fiveY}%` : <Dash />,
          tenY: item.tenY ? `${item.tenY}%` : <Dash />,
          stdExpRatio: item.stdExpRatio ? `${item.stdExpRatio}%` : <Dash />,
          selExpRatio: item.selExpRatio ? `${item.selExpRatio}%` : <Dash />,
          currentNAV: item.currentNAV ? (
            `$${parseFloat(item.currentNAV).toFixed(2)}`
          ) : (
            <Dash />
          ),
          availableUnits: item.availableUnits ? item.availableUnits : <Dash />,
          expRatio: item.expRatio ? item.expRatio : <Dash />,
          currentBalance: item.currentBalance ? formatAmount(item.currentBalance) : (
            <Dash />
          )
        });

        data.push({
          key: index,
          investmentOption: item.investmentOption,
          category: item.category,
          description: item.description,
          returnsYTD: item.returnsYTD ? item.returnsYTD : null,
          oneY: item.oneY,
          fiveY: item.fiveY,
          tenY: item.tenY,
          stdExpRatio: item.stdExpRatio,
          selExpRatio: item.selExpRatio,
          currentNAV: item.currentNAV,
          risk: item.risk,
          availableUnits: item.availableUnits,
          expRatio: item.expRatio,
          currentBalance: item.currentBalance,
          poolId: item.poolId,
          type: item.type,
          benchmark: benchmark,
          isExpanded: poolName === item.investmentOption ? true: item.isExpanded,
          isMyInvestment: item.hasOwnProperty("isMyInvestment")
            ? item.isMyInvestment
            : false
        });        
        
      });

    return (
      <>
        {this.props.print ? (
          <PrintTable
            dataSource={preview}
            columns={this.props.columnConfig}
            tabName={this.props.tabName}
            fundName={this.props.fundName}
            fundId={this.props.fundId}
          />
        ) : data.length > 0 ? (
          <InvestmentTable  
            onRow={(props) => {
              return {
                onClick: event => {                  
                  if (this.state.expandedRow && this.state.expandedRow.length && this.state.expandedRow[0]) {
                    let index = this.state.expandedRow[0].split('_') && this.state.expandedRow[0].split('_')[1];                    
                    if (index && (parseInt(index) === props.key)) {
                      this.expandToggler();
                    } else {
                      this.expandToggler(`iod_${props.key}`);
                    }
                  } else {
                    this.expandToggler(`iod_${props.key}`);
                  }
                }
              }
            }}     
            rowKey={ (props) => { return `iod_${props.key}` } }
            onExpand={ (expanded, record) => {                            
              this.props.findExpanded(record.key, expanded);
            }}
            onChange={ (pagination, filters, sorter, extra) => this.ExportDataexpandToggler(pagination, filters, sorter, extra) }
            rowClassName= { (record) => record.isExpanded ? 'highlight': '' ||  (this.props.tabName && this.props.tabName === "My Investments") ? 'myInvestmentTableIOD': ''}
            hasBorder={true}
            className="main investmentOptionTable"
            columns={this.props.columnConfig} //column config is given here
            dataSource={data} //data for the table is to be given here            
            expandedRowKeys={this.state.expandedRow}
            expandIcon={this.props.columnConfig.length!==5? this.CustomExpandIcon:null} //sets the icon of expansion
            pagination={false} //sets the pagination as false
            expandedRowRender={this.props.columnConfig.length!==5? this.NestedTable:null} //indicates what to show when click on expanded
            expandIconAsCell={false} //Merges expand icon in the below given column number
            expandIconColumnIndex={0} //shows the expand icon on the given column
            scroll={{ y: 500 }} //it is given to stick the header at top if the data row length exceeds given height
          />
        ) : null}
      </>
    );
  }
}
InvestmentOptionDetailsWeb.propTypes = {
  accountID: PropTypes.string,
  className: PropTypes.string,
  columnConfig: PropTypes.array,
  fundData: PropTypes.array,
  isLoadingUnderlyingTable: PropTypes.bool,
  print: PropTypes.bool,
  staticContext: PropTypes.string,
  tabName: PropTypes.string,
  tableData: PropTypes.object
}

const mapStateToProps = state => ({  
  ...investmentInvestmentOptionDetailsDerivedStates(state.toJS())
   });

export default withRouter(
  connect(
    mapStateToProps    
  )(InvestmentOptionDetailsWeb)
);
